import { z } from "zod";

// ─── POST /api/non-invoice-incoming/:id/assign-invoice ────────────────────────

export const AssignNonInvoiceRequestSchema = z.object({
  invoice_id: z.string().uuid(),
});
export type AssignNonInvoiceRequest = z.infer<typeof AssignNonInvoiceRequestSchema>;

export const AssignNonInvoiceResponseSchema = z.object({
  niit_id: z.string().uuid(),
  invoice_id: z.string().uuid(),
  match_status: z.literal("manual"),
  matched_at: z.string().datetime(),
  invoice_payment_match_status: z.enum(["OPŁACONA", "CZĘŚCIOWO_OPŁACONA"]).nullable(),
});
export type AssignNonInvoiceResponse = z.infer<typeof AssignNonInvoiceResponseSchema>;

// ─── DELETE /api/non-invoice-incoming/:id/assign-invoice ─────────────────────

export const UnassignNonInvoiceResponseSchema = z.object({
  niit_id: z.string().uuid(),
  invoice_id: z.string().uuid(),
  invoice_payment_match_status: z.enum(["OPŁACONA", "CZĘŚCIOWO_OPŁACONA"]).nullable(),
});
export type UnassignNonInvoiceResponse = z.infer<typeof UnassignNonInvoiceResponseSchema>;

// ─── GET /api/non-invoice-incoming/unassigned ─────────────────────────────────

export const UnassignedNonInvoiceItemSchema = z.object({
  id: z.string().uuid(),
  booking_date: z.string(),
  amount: z.string(),
  counterparty: z.string().nullable(),
  description: z.string(),
  category: z.string(),
});
export type UnassignedNonInvoiceItem = z.infer<typeof UnassignedNonInvoiceItemSchema>;

export const UnassignedNonInvoiceResponseSchema = z.object({
  transfers: z.array(UnassignedNonInvoiceItemSchema),
  total: z.number(),
});
export type UnassignedNonInvoiceResponse = z.infer<typeof UnassignedNonInvoiceResponseSchema>;
